import {Stack, Typography} from '@mui/material';
import React from 'react';

import {FinishWithoutCompleteFlowEnum} from 'main/analytics/gaTagsEnum';
import {AlertModal, CTAButtonFixed} from 'presentation/components';
import {BookingEmptyState} from 'presentation/modules/booking/shared/ui/components/BookingEmptyState';
import {BookingErrorState} from 'presentation/modules/booking/shared/ui/components/BookingErrorState';
import {BookingLoadingState} from 'presentation/modules/booking/shared/ui/components/BookingLoadingState';
import {BookingNotFoundVariantEnum} from 'presentation/modules/booking/shared/ui/components/BookingNotFoundDialog/types';
import {BookingNotFoundListCard} from 'presentation/modules/booking/shared/ui/components/BookingNotFoundListCard';
import {DistrictList} from 'presentation/modules/booking/shared/ui/components/DistrictList';

import {translations} from 'presentation/translations-new';
import {OdontoDistrictNotFoundState} from './components/OdontoDistrictNotFoundState';
import {useOdontoDistrictSelection} from './hooks/useOdontoDistrictSelection';
import {DistrictsProps} from './types';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';

const {
	loadingError,
	loadingState,
	emptySearchState,
	notFoundModal: {cardListText},
	emptyModal: {part1, part2},
} = translations['pt-br'].privateFlow.bookingFlow.districtFlow;
const {goForward, notice, understood} = translations['pt-br'].commons;

export function OdontoDistrictSelection({handleNextStep}: DistrictsProps) {
	const {
		isLoading,
		districtListHasError,
		districtListHasUnprocessableError,
		refetch,
		showNotFoundState,
		showEmptyState,
		filteredDistrictList,
		handleSelectCard,
		selectedDistricts,
		handleGoForward,
		showEmptyDistrictsModal,
		setShowEmptyDistrictsModal,
	} = useOdontoDistrictSelection({handleNextStep});

	if (districtListHasError && !districtListHasUnprocessableError) {
		return (
			<BookingErrorState
				showHeader={false}
				errorTitle={loadingError}
				handleRefresh={refetch}
			/>
		);
	}

	if (isLoading) {
		return <BookingLoadingState showHeader={false} loadingText={loadingState} />;
	}

	if (showNotFoundState) {
		return <OdontoDistrictNotFoundState />;
	}

	if (showEmptyState) {
		return (
			<BookingEmptyState
				description={emptySearchState.emptyDistrictAll}
				flowType={FlowEnum.ODONTO}
				dataTagId={FinishWithoutCompleteFlowEnum.SEM_BAIRRO_ENCONTRADO}
			/>
		);
	}

	return (
		<Stack gap={2}>
			<DistrictList
				list={filteredDistrictList}
				handleSelectCard={handleSelectCard}
				selectedDistricts={selectedDistricts}
			/>
			<Stack mt={2} id="go-forward-button">
				<BookingNotFoundListCard
					flowType={FlowEnum.ODONTO}
					customOrientationText={cardListText}
					variant={BookingNotFoundVariantEnum.DISTRICT}>
					<CTAButtonFixed.Root>
						<CTAButtonFixed.Action fullWidth onClick={handleGoForward} size="large">
							{goForward}
						</CTAButtonFixed.Action>
					</CTAButtonFixed.Root>
				</BookingNotFoundListCard>
			</Stack>

			{showEmptyDistrictsModal ? (
				<AlertModal
					open={showEmptyDistrictsModal}
					headerTitle={notice}
					variant="info"
					onClose={() => setShowEmptyDistrictsModal(false)}
					buttonLabel={understood}
					slotProps={{
						paper: {
							style: {
								maxWidth: 420,
								width: '100%',
							},
						},
					}}
					subDescription={
						<Typography variant="h6" fontSize={18} textAlign="center" fontWeight={600}>
							{part1} <br /> {part2}
						</Typography>
					}
				/>
			) : null}
		</Stack>
	);
}
